import { platformQueryCreditCost } from '@lensora/shared'
import { cn } from '@lensora/ui'

import { PlatformIcon, formatPlatformName } from '@/components/dashboard/PlatformIcon'

// Deliberately NOT filtered by isGrowthGatedPlatform — a completed
// architecture + security review concluded onboarding should offer all
// four grounded-search platforms regardless of the tenant's plan tier,
// since Growth-gating is enforced nowhere server-side today (confirmed:
// POST /api/simulate accepts and runs any of these for any tenant) and a
// locked chip at the single highest-intent moment in the funnel is a
// conversion cost, not a conversion lever. Do not "fix" this to use
// isGrowthGatedPlatform.
const GROUNDED_DEMO_PLATFORMS = ['perplexity', 'google-ai', 'chatgpt-search', 'claude-search'] as const

interface PlatformPickerTurnProps {
  resolved: boolean
  summary?: string | undefined
  saving: boolean
  onSelect: (platform: string) => void
}

export function PlatformPickerTurn({ resolved, summary, saving, onSelect }: PlatformPickerTurnProps) {
  if (resolved) {
    return <p className="text-sm text-text-muted">{summary}</p>
  }

  return (
    <div className="flex flex-wrap gap-2">
      {GROUNDED_DEMO_PLATFORMS.map((platform) => {
        const cost = platformQueryCreditCost(platform)
        return (
          <button
            key={platform}
            type="button"
            disabled={saving}
            onClick={() => onSelect(platform)}
            className={cn(
              'flex items-center gap-2 rounded-full border border-border bg-surface px-3.5 py-1.5 text-left text-xs font-medium text-text transition-colors',
              'hover:border-brand-accent/40 disabled:cursor-not-allowed disabled:opacity-60'
            )}
          >
            <PlatformIcon platform={platform} size={16} />
            {formatPlatformName(platform)}
            {platform === 'perplexity' && (
              <span className="rounded-full bg-brand-accent/10 px-1.5 py-0.5 text-[10px] font-semibold text-brand-accent">
                Fastest
              </span>
            )}
            <span className="text-[10px] text-text-muted">{cost} credit{cost === 1 ? '' : 's'}</span>
          </button>
        )
      })}
    </div>
  )
}
